module.exports = __webpack_public_path__ + "static/media/9.f6ac329b.svg";